import React from "react";

import { Lending } from "../../components/Lending";

export const LendingLibraria = () => {
  return  <Lending type='libraria' title="Libraria"/>
};
